export interface ManagedContentServerData {
  Title: string;
  Body: string;
}

export interface ManagedContent {
  title: string;
  body: string;
}

export interface Organization {
  companyName: string;
  mainAddress: string;
  telephoneNo: string;
  faxNo: string;
}

export interface OrganizationServerData {
  CompanyName: string;
  MainAddress: string;
  TelephoneNo: string;
  FaxNo: string;
}

export interface ContactPerson {
  organizationRepresentative: string;
  emailAddress: string;
  mobileNo: string;
}

export interface ContactPersonServerData {
  OrganizationRepresentative: string;
  EmailAddress: string;
  MobileNo: string;
}

export interface FileUpload {
  fileId: string;
  name: string;
  data: string;
  size?: number | null;
  type?: string;
  documentType?: string;
}

// File ID - Used to uniquely identify the file
// Should be generated by the backend server for storage
// For server to retrieve/return the correct file details
export interface FileUploadServerData {
  FileId: string;
  Name: string;
  Data: string;
  Size?: number | null;
  Type?: string;
  DocumentType?: string;
}

export interface Investment {
  name: string;
  dateOfPurchase: string;
  currency: string;
  amountInvested?: number;
  tenorValue?: number;
  tenorUnit: string;
}

export interface InvestmentServerData {
  Name: string;
  DateOfPurchase: string;
  Currency: string;
  AmountInvested?: number;
  TenorValue?: number;
  TenorUnit: string;
}

export interface QuestionOption {
  id: string;
  title: string;
  description?: string;
}

export interface Question {
  id: string;
  index: number;
  label: string;
  selectedOption?: string;
  options: QuestionOption[];
}

export interface QuestionList {
  category: string;
  questions: Question[];
}

export interface QuestionOptionServerData {
  Id: string;
  Title: string;
  Description?: string;
}

export interface QuestionServerData {
  Id: string;
  Label: string;
  SelectedOption?: string;
  Options: QuestionOptionServerData[];
  Category: string;
}

export interface QuestionSubmitData {
  Id: string;
  SelectedOption: number;
}

export enum RiskLevel {
  CONSERVATIVE = 'Conservative',
  MODERATE = 'Moderate',
  AGGRESSIVE = 'Aggressive',
}

export enum RiskComparedResult {
  Declared_Less_Than_Assessed,
  Declared_More_Than_Assessed,
  Declared_Equal_To_Assessed,
}

export enum Workflow {
  AI = 'ai',
  FNA = 'fna',
}

export interface Product {
  id: number;
  riskLevel: string;
  title: string;
  description?: string;
  shortDescription?: string;
}

export interface ProductServerData {
  Id: number;
  RiskLevel: string;
  Title: string;
  Description?: string;
  ShortDescription?: string;
}

export interface ProductOption extends Product {
  isChecked: boolean;
  hide:boolean
}

export interface ProductOptionServerData extends ProductServerData {
  IsChecked?: boolean;
}

export interface ProductDetailDescription {
  lowRiskDescription: string;
  moderateRiskDescription: string;
  highRiskDescription: string;
}

export interface LoginSMSOTPResponse {
  Status: boolean; // false if SMS OTP submitted is invalid/wrong.
  LastVisitedScreenName: string; // User will be redirected to the last visited screen.
}

export interface SubmitFNACompletionResponse {
  Status: boolean;
  DocuSignURL: string;
}

export interface GlobalDataResponse {
  InvestmentCurrencyList: string[];
  RecommendedProducts: ProductServerData[];
  NonRecommendedProducts: ProductServerData[];
}

export interface DocusignStatusResponse {
  Status: string;
}
